
import React from 'react'
import {StaticRouter} from 'react-router'

import TacosContainerPage from '../../views/TacosContainerPage'

import {  withRouter, Link } from "react-router-dom"
import PearlTerrain from './PearlTerrain'
import {SVFancyNav} from "./SVFancyNav"

const {noop} = StaticRouter

function TacosListPage(){
    return <h3>Tacos List Page</h3>;
  
  }
  function Bus() {
    return <h3>Bus</h3>;
  }

class SVHeaderItem extends  React.Component{

    constructor(props){
        super(props)
        let me = this
        this.getFancyBar = this.getFancyBar.bind(me)
        

    }
    getFancyBar(ar){
        return (<SVFancyNav></SVFancyNav>)

    }
    render(){
        let svIsActive = false
       
        console.log('sv******SVHeaderItem props start')
        console.log(this.props)
        //const {index, to, children, ...props} = this.props
        const {history, location, to} = this.props

        const {index, children, ...props} = this.props
        let myname = to
       
        console.log(myname)
        const {pathname} = location
        console.log(pathname)
       
        if (pathname == myname){
            console.log('sv******SVHeaderItem svIsActive true')
            svIsActive = true
        }else{
            console.log('sv******SVHeaderItem svIsActive false')
            svIsActive = false
        }
        console.log('sv******SVHeaderItem props end')
        let mychilds  = [
            {
              path: "/tacos/list",
              component: TacosListPage
            },
            {
              path: "/tacos/:id",
              component: TacosContainerPage
            },
            
            {
              path: "/tacos/bus",
              component: Bus
            }
          ]


      
        
        const SVLink = Link
        return(
            <div>
                <li className={svIsActive? "active":""}>
                <SVLink to={to} {...props} > {children}</SVLink>
                </li>
                {/* <PearlTerrain body={this.getFancyBar(mychilds)}></PearlTerrain>
        */}
            </div>
           


        )
    }

}

SVHeaderItem = withRouter(SVHeaderItem)
export default SVHeaderItem